import { Routes } from '@angular/router';

/**
 * Extrai mapa path → roles dos children da rota raiz.
 * Ex: '/analise' → ['geo-visualizer-web.gerenciar_analises']
 */
export function buildRouteRolesMap(routes: Routes): Map<string, string[]> {
    const map = new Map<string, string[]>();
    const root = routes.find((r) => r.children);
    if (!root?.children) return map;

    for (const child of root.children) {
        if (child.path !== undefined && child.data?.['roles']) {
            map.set(child.path, child.data['roles']);
        }
    }
    return map;
}
